module.exports = __webpack_public_path__ + "img/07-transforming-cities-for-decent.ea0d1a37.jpg";